define('modules/targeting/digital/main',["T1Module"], function (T1Module) {
  "use strict";

  return new T1Module({
    name: "targeting/digital",
    viewCfgs: {
      panel: {
        collection: null
      },
      browse: {
        collection: null
      },
      filter: {
        collection: null
      },
      bins: {
        collection: null
      },
      readOnly: {
        model: null
      }
    },
    getView: function (type, opts) {
      if (type === "panel") {
        opts.strategyTargetDimensions = opts.strategy.fetchTargetDimensions();
      }
      return T1Module.prototype.getView.call(this, type, opts);
    }
  });
});
